export default __webpack_public_path__ + "static/media/a015-3.c16728ae.svg";